// extracted by mini-css-extract-plugin
export default {"Title":"CalendarReports_Title__wkZG+"};